import React from 'react'
import { Link, browserHistory } from 'react-router'
import Navigation from './Navigation'
import Logo from './Logo'
import Search from './Search'

const propTypes = {
  mode: React.PropTypes.string.isRequired,
  setMode: React.PropTypes.func.isRequired,
  setCenter: React.PropTypes.func.isRequired,
  setBounds: React.PropTypes.func.isRequired,
  setSelectedObject: React.PropTypes.func.isRequired,
}

class Header extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="Header">

        <Navigation
          mode={this.props.mode}
          setMode={this.props.setMode}
        /> 

        <Search 
          setBounds={this.props.setBounds}
          unsetSelectedEntity={this.props.unsetSelectedEntity}
        />
      </div>
    )
  }
}

Header.propTypes = propTypes

export default Header


// WEBPACK FOOTER //
// ./src/components/Header.js